webpackJsonp([185579923683717],{

/***/ 1282:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/en/Culture/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---en-culture-a56238c5b8ffe425f325.js